import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 40201 49132"
    {...props}
  >
    <path
      d="M13216 27670H9786v15501c0 2047-450 3543-1350 4510s-2081 1451-3521 1451c-1563 0-2778-506-3633-1518S0 45127 0 43171V5995c0-2103 472-3633 1417-4578S3892 0 5995 0h15917c2193 0 4071 90 5634 281 1564 191 2970 563 4219 1136 1518 642 2857 1552 4026 2733 1159 1193 2048 2577 2644 4140 608 1574 911 3239 911 5006 0 3599-1012 6478-3048 8638-2036 2149-5118 3678-9246 4578 1732 923 3397 2284 4982 4083 1575 1800 2993 3724 4230 5748 1237 2036 2204 3858 2902 5500 686 1631 1035 2756 1035 3375 0 630-203 1259-608 1890-404 630-956 1124-1665 1485-697 360-1518 539-2440 539-1092 0-2013-259-2768-776-741-518-1383-1170-1922-1957-541-788-1272-1957-2194-3487l-3926-6524c-1406-2384-2666-4207-3767-5455-1115-1261-2239-2115-3386-2576-1137-461-2577-687-4309-687zm5602-20314H9786v13296h8762c2351 0 4331-203 5939-607 1597-406 2823-1103 3667-2082 844-978 1271-2328 1271-4038 0-1350-337-2531-1024-3554-675-1024-1619-1788-2834-2295-1136-483-3386-720-6749-720z"
      style={{
        fill: "#2b2a29",
        fillRule: "nonzero",
      }}
      className="fill"

    />
  </svg>
)
export default SvgComponent
